import { Store } from '@ngxs/store';
import { take, map, distinctUntilChanged, filter, delay } from 'rxjs/operators';
import { EngineState } from '../engine/state/engine.state';
import { AddHistory, RevertChapterSynchronization, CopyChapterSynchronization } from './state/history.actions';
import { HistoryModel } from './models/history.model';
import { HistoryAction } from './models/history-action.enum';
import { StoryChaptersState } from '../story/state/chapters/story.chapters.state';
import { HistoryState } from './state/history.state';
import { SetChapter } from '../story/state/chapters/story.chapters.actions';
import { ChapterService } from '../story/chapter.service';
import { SetCheckedNodes } from '../engine/state/nodes/engine.nodes.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../story/chapter.service";
export class HistoryService {
    constructor(store, chapterService) {
        this.store = store;
        this.chapterService = chapterService;
    }
    /**
     * Tap into the viewgraph events to record next state. Because viewgraph changes occur asynchronously from the engine,
     * we wait until the synchornize event is called to tap into and update history.
     */
    recordViewGraphHistory() {
        const viewGraph$ = this.store.select(EngineState.getViewGraph);
        viewGraph$
            .pipe(delay(1), filter(viewGraph => Object.values(viewGraph.nodes).length > 0), map(viewGraph => {
            const nodes = Object.values(viewGraph.nodes)
                .reduce((result, node) => {
                result[node.id] = { id: node.id, boolState: { shown: node.boolState.shown } };
                return result;
            }, {});
            return JSON.stringify(nodes);
        }), distinctUntilChanged(), take(1))
            .subscribe((viewGraph) => {
            const nodes = JSON.parse(viewGraph);
            this.store.dispatch(new AddHistory(new HistoryModel(HistoryAction.SetNodeVisible, nodes)));
        });
    }
    resetChapter() {
        let chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
        if (!chapter) {
            return;
        }
        this.store.dispatch(new RevertChapterSynchronization('root', chapter.id));
        this.store.dispatch(new CopyChapterSynchronization('root', chapter.id, 'cache', chapter.id));
        const cache = this.store.selectSnapshot(HistoryState).cache;
        const synchronization = cache[`root_${chapter.id}`];
        chapter = Object.assign({}, chapter, { synchronization: Object.assign({}, synchronization) });
        this.store.dispatch(new SetCheckedNodes([])); // reset checked nodes.
        this.store.dispatch(new SetChapter(chapter));
        this.chapterService.addChapterToEngine(chapter, 0);
    }
}
HistoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HistoryService_Factory() { return new HistoryService(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.ChapterService)); }, token: HistoryService, providedIn: "root" });
